export const SPECIES_MAP = {
  dog: 'Dog',
  cat: 'Cat',
};

export const GENDER_MAP = {
  M: 'Male',
  F: 'Female',
};
